import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { injectReportsHttpApiService } from '@core/reports-contracts';
import type { ReportDashboardMetricOptions } from '@core/reports-types';

@Injectable()
export class ReportsMetricsHttpClient {
  private httpApi = injectReportsHttpApiService();

  public fetchCollection(): Observable<{ metrics: ReportDashboardMetricOptions[] }> {
    return this.httpApi.get<{ metrics: ReportDashboardMetricOptions[] }>('/metrics');
  }
}
